import { Phone, Mail, MessageCircle, MapPin } from "lucide-react";
import { BRAND, IMAGES } from "../../data";

export const Footer = () => (
  <footer data-testid="footer" className="relative bg-[#060B14] border-t border-white/10 pt-20 pb-10">
    <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 pb-16">
        <div className="lg:col-span-5">
          <img src={IMAGES.logoDark} alt="DrivePrestige — Chauffeur VTC Premium" className="w-56 h-auto object-contain rounded-xl border border-white/10 mb-6" />
          <p className="text-[#94A3B8] max-w-sm text-sm leading-relaxed">
            Chauffeur VTC premium au service de vos trajets dans l'Aube, la Marne et la Haute-Marne. Sécurité, confort et discrétion, 7j/7.
          </p>
        </div>

        <div className="lg:col-span-4 lg:col-start-9 space-y-4">
          <p className="text-xs uppercase tracking-[0.3em] text-champagne font-semibold mb-6">Contact</p>
          <a data-testid="footer-whatsapp" href={`https://wa.me/${BRAND.whatsapp}`} target="_blank" rel="noreferrer" className="flex items-center gap-4 text-[#F7F5F0] hover:text-champagne transition-colors group">
            <MessageCircle size={18} className="text-champagne" /> {BRAND.phoneDisplay} <span className="text-[#94A3B8] text-sm">(WhatsApp)</span>
          </a>
          <a data-testid="footer-phone" href={`tel:+${BRAND.whatsapp}`} className="flex items-center gap-4 text-[#F7F5F0] hover:text-champagne transition-colors">
            <Phone size={18} className="text-champagne" /> {BRAND.phoneDisplay}
          </a>
          <a data-testid="footer-email" href={`mailto:${BRAND.email}`} className="flex items-center gap-4 text-[#F7F5F0] hover:text-champagne transition-colors">
            <Mail size={18} className="text-champagne" /> {BRAND.email}
          </a>
          <p className="flex items-center gap-4 text-[#94A3B8]">
            <MapPin size={18} className="text-champagne" /> Aube · Marne · Haute-Marne
          </p>
        </div>
      </div>

      <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4 text-[#94A3B8] text-xs">
        <p>© {new Date().getFullYear()} {BRAND.name}. Tous droits réservés.</p>
        <p>Disponible 7j/7 · Toutes destinations</p>
      </div>
    </div>
  </footer>
);
